export const id = 'shift2DX';
export const name = 'Shift 2D X';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: true,
    updateYDomain: false,
};
export function apply(datum2D, options) {
    const { shift } = options;
    const data = { ...datum2D.data };
    for (const key in data) {
        data[key].minX += shift;
        data[key].maxX += shift;
    }
}
export function isApplicable() {
    return true;
}
export function reduce(previous, next) {
    const { shift: previousValue = 0 } = previous;
    const { shift: nextShift } = next;
    return {
        once: true,
        reduce: previousValue + nextShift,
    };
}
//# sourceMappingURL=shiftX.js.map